// extracted by mini-css-extract-plugin
export default {"root":"ChangePhoneMenu_root__JRg1K","top":"ChangePhoneMenu_top__UgX-3","middle":"ChangePhoneMenu_middle__kK62q","bottom":"ChangePhoneMenu_bottom__jrj2t"};